import React from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { RiHotelLine } from "react-icons/ri";


const NotArrangeCard = ({
  dashboardData,
  second,
  heading,
  day,
  bgcolor,
  link,
}) => {
  return (
    <>
      {/* <div class="col">
      <Link to={link}>
      
    <div class="card adminuiux-card">
        <div class="card-body">
        <p class="text-secondary small mb-2">Not Arranged Hotel</p>
        <h4 class="mb-3">$13.20k</h4>
        <span class="badge badge-light text-bg-success"
            ><i class="me-1 bi bi-arrow-up-short"></i>28.50%</span>
        </div>
    </div>
      </Link>
    </div> */}

      <div className="col">
        <Link
          to={link}
          style={{
            textDecoration: "none",
          }}
        >
          <div className="not-arrange-card">
            <div className="row">
              <div className="col-6 d-flex align-items-center justify-content-center" >
                <RiHotelLine style={{
                  fontSize: "4.5em",
                  color: "#fff",
                }}/>
              </div>
              <div className="col-6">
                <p className="not-arrange-card-heading">{heading}</p>
                <h1 className="">
                  <CountUp end={dashboardData && second} />
                </h1>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default NotArrangeCard;
